import { Component } from '../core/Component';
import { Vector2 } from '../core/Vector2';

/**
 * Transform component for handling position, rotation, and scale
 * Pure data component - no behavior/logic
 */
export class TransformComponent extends Component {
  public position: Vector2;
  public rotation: number;
  public scale: Vector2;

  constructor(
    position: Vector2 = new Vector2(0, 0),
    rotation: number = 0,
    scale: Vector2 = new Vector2(1, 1)
  ) {
    super();
    this.position = position;
    this.rotation = rotation;
    this.scale = scale;
  }

  public clone(): TransformComponent {
    return new TransformComponent(
      this.position.clone(),
      this.rotation,
      this.scale.clone()
    );
  }
}
